import { ImportCsv } from "components/Layout/ImportCsv/ImportCsv";

interface Props {
  isSegmentActive?: boolean;
  openImportCsvModal: () => void;
}

export const EmptySegment = ({ openImportCsvModal }: Props) => {
  return (
    <ImportCsv
      title="addFirstMembersToSegment"
      subtitle="importMembersInCsvInfo"
      actionButtonText="importCsv"
      importGuideButtonLabel="importGuide"
      guideLink="https://help.openloyalty.io/main-features/members/segments"
      openModal={openImportCsvModal}
    />
  );
};
